import React from 'react';
import { Mail, X } from 'lucide-react';

interface EmailVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  onVerificationComplete?: () => void;
}

const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({
  isOpen,
  onClose,
  email
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-500 transition-colors"
        >
          <X size={24} />
        </button>

        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#9a6ebd]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail className="w-8 h-8 text-[#9a6ebd]" />
          </div>
          <h3 className="text-xl font-semibold text-[#323c5f] mb-4">
            Vérifiez votre email
          </h3>
          <p className="text-gray-600 mb-4">
            Un email de confirmation a été envoyé à <strong>{email}</strong>
          </p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
            <p className="font-medium mb-2">Instructions :</p>
            <ol className="list-decimal list-inside space-y-2 text-left">
              <li>Ouvrez votre boîte mail</li>
              <li>Cliquez sur le lien de vérification dans l'email</li>
              <li>Une fois vérifié, vous pourrez vous connecter</li>
            </ol>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-[#9a6ebd] text-white px-6 py-3 rounded-lg hover:bg-[#8a5dad] transition-colors"
        >
          Fermer
        </button>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            Si vous ne trouvez pas l'email, vérifiez votre dossier spam.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal;